(function MoveBetweenLists($, Adzuki)
{
	"use strict";

	var MoveBetweenLists = {};

	// public properties
	MoveBetweenLists.containerElement = null;
	MoveBetweenLists.leftElement      = null;
	MoveBetweenLists.rightElement     = null;
	MoveBetweenLists.hiddenElement    = null;

	MoveBetweenLists.setProperties = function setProperties($element) {
		this.containerElement  = $element.parents('.move-between-lists');
		this.leftElement       = this.containerElement.find('.left-field');
		this.rightElement      = this.containerElement.find('.right-field');
		this.hiddenElement     = this.containerElement.find('.hidden_multiselect').find('select');
		this.leftCountElement  = this.leftElement.find('.list-count .number');
		this.rightCountElement = this.rightElement.find('.list-count .number');
	};

	// get all of the checked checkboxes within $element > .option-container
	MoveBetweenLists.getCheckedByParentElement = function getCheckedByParentElement($element) {
		return $element.find('.option-container').not('.hidden').find(':checkbox:checked');
	};

	MoveBetweenLists.getListCount = function getListCount(side) {
		var number_text = null;

		if (side === 'left') {
			number_text = parseInt(this.leftCountElement.html()) || null;
		} else if (side === 'right') {
			number_text = parseInt(this.rightCountElement.html()) || null;
		}

		return number_text;
	};

	// check all checkboxes within a group's div
	MoveBetweenLists.toggleCheckedAllInGroup = function toggleAllInGroup($group_arr, checked_value) {
		var i   = 0,
		    len = $group_arr.length;

		for (i; i < len; i++) {
			$group_arr[i].checked = checked_value;
		}
	};

	// check all checkboxes within a parent div
	MoveBetweenLists.toggleCheckAll = function toggleCheckAll($parent_element, checked_value) {
		var $parent_divs = $parent_element.find('.option-container').not('.filtered-hidden'),
			$checkboxes  = $parent_divs.find(':checkbox'),
		    i            = 0,
		    len          = $checkboxes.length;

		for (i; i < len; i++) {
			$checkboxes[i].checked = checked_value;
		}
	};

	// get the data-selected-value attribute and make sure it's an int
	MoveBetweenLists.getDataValueInt = function getDataValueInt($element) {
		var $selected_value = $element.data('selected-value');

		if (parseInt($selected_value)) {
			return parseInt($selected_value);
		} 
		
		return $selected_value;
	
	};

	/**
	 * Mark options in a hidden multi-select as selected
	 * @param jQuery object  $parent the container div of this whole thing
	 * @param mixed  value   the option value moved over
	 */
	MoveBetweenLists.toggleHiddenInputValues = function toggleHiddenInputValues(values, selected) {
		var $hidden_select_options = this.hiddenElement.find('option'),
		    $option                = null,
		    option_value           = 0,
		    i                      = 0,
		    len                    = $hidden_select_options.length,
		    firstIndex             = 0;

		for (i; i < len; i++) {  // loops thru all hidden select options
			$option      = $($hidden_select_options[i]);

			if (parseInt($option.val())) {
				option_value = parseInt($option.val());
			} else {
				option_value = $option.val();
			}

			if (values.indexOf(option_value) >= firstIndex) {
				$option.prop('selected', selected);
			}
		}

		if (values.length > 0) {
			this.hiddenElement.trigger('change');
		}
	};

	// show/hide .option-container divs in the left or right container div
	MoveBetweenLists.toggleMultipleInColumn = function toggleMultipleInColumn(side, values, show) {
		var $side         = null,
		    $option_divs  = null,
			$self         = null,
			$checkbox     = null,
			dataInt       = 0,
			i             = 0,
			len           = 0,
			firstIndex    = 0,
			affectedCount = 0;

		if (side === 'right') {
			$side = this.rightElement;
		} else {
			$side = this.leftElement;
		}
		$option_divs = $side.find('.option-container');
		len          = $option_divs.length;

		for (i; i < len; i++) {
			$self      = $($option_divs[i]);
			$checkbox  = $self.find(':checkbox');
			dataInt    = this.getDataValueInt($self);

			if (values.indexOf(dataInt) >= firstIndex) {
				if (show === true) {
					if ($checkbox.length) {
						$checkbox.prop("checked", false);
					}
					$self.removeClass('hidden');
				} else {
					$self.addClass('hidden');
				}
				affectedCount++;
			}
		}
		this.setListCount(side, show, affectedCount);
	};

	// Move any checked checkboxes from left to right
	MoveBetweenLists.moveChecked = function moveChecked() {
		var $checked_fields      = this.getCheckedByParentElement(this.leftElement),
		    checked_values       = [],
		    $checkbox            = null,
		    $checkbox_parent     = null,
		    i                    = 0,
		    len                  = $checked_fields.length;

		for (i; i < len; i++) {

			$checkbox        = $($checked_fields[i]);
			$checkbox_parent = $checkbox.closest("li");

			if (parseInt($checkbox.val())) {
				checked_values[checked_values.length] = parseInt($checkbox.val());
			} else {
				checked_values[checked_values.length] = $checkbox.val();
			}

			$checkbox_parent.addClass('hidden');
		}

		this.toggleHiddenInputValues(checked_values, true);
		this.toggleMultipleInColumn('right', checked_values, true);
		this.toggleGroupHeadings();

		this.setListCount('left', false, checked_values.length);
	};

	/**
	 * set the count of visible options underneath the list
	 * @param string   side       "right" or "left"
	 * @param boolean  increment  true if you want to increment by the count, false if you want to decrement
	 * @param int      count      number to increment or decrement
	 */
	MoveBetweenLists.setListCount = function setListCount(side, increment, count) {
		var current_count   = null,
		    $element_to_set = null,
		    new_count       = null,
		    min_length      = 1;

		// If this property doesn't have a length, the element does not exist and no point in proceeding.
		if (this.leftCountElement.length < min_length) {
			return;
		}

		if (side === 'left') {
			current_count  = this.getListCount('left');
			$element_to_set = this.leftCountElement;
		}
		if (side === 'right') {
			current_count  = this.getListCount('right');
			$element_to_set = this.rightCountElement;
		}

		if (increment) {
			new_count = (current_count + count);
		} else {
			new_count = (current_count - count);
		}

		$element_to_set.html(new_count);

		if (side === 'right') {
			this.hiddenElement.trigger('countChanged', this.getListCount('right'));
		}
	};

	// remove_values should be an array
	MoveBetweenLists.removeSelectedItems = function removeSelectedItems(remove_values) {
		this.toggleHiddenInputValues(remove_values, false);
		this.toggleMultipleInColumn('right', remove_values, false);
		this.toggleMultipleInColumn('left', remove_values, true);
		this.toggleGroupHeadings();
	};

	// Check all checkboxes on the left and then move all checked to the right
	MoveBetweenLists.moveAll = function moveAll() {
		this.toggleCheckAll(this.leftElement, true);
		this.moveChecked();
	};

	// Toggle group heading for both sides
	MoveBetweenLists.toggleGroupHeadings = function toggleGroupHeadings() {
		this.toggleGroupHeading(this.leftElement);
		this.toggleGroupHeading(this.rightElement);
	};

	// If groups are being used, need to show or hide the group header depending on if any options are visible beneath it
	MoveBetweenLists.toggleGroupHeading = function toggleGroupHeading($element) {
		var $group = $element.find('.options .group');

		$group.each(function groupLoop(i, ele) {
			var $self         = $(ele),
			    $options      = $self.find('.option-container'),
			    $group_header = $self.find('.group-label'),
			    hasAtLeastOne = false;

			$options.each(function areNotHiddden(i, ele) {
				var $self = $(ele);
				if (!$self.hasClass('hidden')) {
					hasAtLeastOne = true;
					return false;
				}
			});

			if (hasAtLeastOne) {
				$group_header.removeClass('hidden');
				if ($element.hasClass('left-field')) {
					$group_header.find(':checkbox').prop('checked', false);
				}
			} else {
				$group_header.addClass('hidden');
			}
		});
	};

	// Filter the "from" list based on text entered by the user
	MoveBetweenLists.filterList = function filterList(text, $side) {
		var $containers   = $side.find('.option-container').not('.hidden'),
		    i             = 0,
		    len           = $containers.length,
		    $container    = null,
		    label         = '',
		    lower_text    = text.toLowerCase(),
		    visible_count = 0,
		    $clear_button = $side.find('.clear-filter');

		// eslint-disable-next-line no-magic-numbers
		if (text.length > 0) {
			$clear_button.removeClass('hidden');
		} else {
			$clear_button.addClass('hidden');
		}

		for (i; i < len; i++) {
			$container  = $($containers[i]);
			label       = $container.find("label").html();

			// eslint-disable-next-line no-magic-numbers
			if (label.toLowerCase().indexOf(lower_text) < 0) {
				$container.addClass('filtered-hidden');

			} else {
				if ($container.hasClass('filtered-hidden')) {
					$container.removeClass('filtered-hidden');
				}
				visible_count++;
			}
		}
		this.leftCountElement.html(visible_count);
	};

	// Completely remove option from left, right, and hidden multiselect
	MoveBetweenLists.removeCompletely = function removeCompletely(value)
	{
		var selected = false; // is this value currently selected?

		// Remove li element from right side
		$('#move-between-lists-container .right-field li[data-selected-value=' + value +']').each(function removeRightLi(index, el) {
			el.remove();
		});
		// Remove li element from left side
		$('#move-between-lists-container .left-field li[data-selected-value=' + value +']').each(function removeLeftLi(index, el) {
			el.remove();
		});
		// remove the actual option from the hidden multiselect
		$('#move-between-lists-container .hidden_multiselect option[value=' + value +']').each(function removeOption(index, el) {
			if (el.selected) {
				selected = true;
			}
			MoveBetweenLists.setProperties($(el));
			el.remove();
		});

		if (selected) {
			MoveBetweenLists.setListCount('right', false, 1);
		} else {
			MoveBetweenLists.setListCount('left', false, 1);
		}
	};

	// Clear whatever filter has been applied
	MoveBetweenLists.clearFilterList = function clearFilterList($side) {
		var $filter_input = this.containerElement.find('.move-between-filter');

		$filter_input.val('');

		this.filterList('', $side);
	};

	MoveBetweenLists.init = function init()
	{
		var filter_timeout,
		    filter_delay = 200;

		if ($(".move-between-lists").length > 0) {

			// When "Add All" button clicked, move all from left to right
			$(".move-between-lists .controls .add-all").on('click', function addAll(e) {
				var $self       = $(this);
				e.preventDefault();

				Adzuki.CustomConfirm({
					body   : 'Are you sure you wish to add all?',
					confirm: function yes() {
						MoveBetweenLists.setProperties($self);
						MoveBetweenLists.moveAll();
						MoveBetweenLists.toggleGroupHeadings();
						MoveBetweenLists.clearFilterList(MoveBetweenLists.leftElement);
					}
				});
			});

			// When "Add Checked" button clicked, only move checked
			$(".move-between-lists .controls .add-selected").on('click', function addSelected(e) {
				var $self = $(this);
				e.preventDefault();
				MoveBetweenLists.setProperties($self);
				MoveBetweenLists.moveChecked();
			});

			// Remove from right side
			$(".move-between-lists .right-field .remove").on('click', function removeItem(e) {

				var $self             = $(this),
				    $option_container = $self.parents('.option-container'),
				    remove_value      = MoveBetweenLists.getDataValueInt($option_container),
				    remove_values     = [];

				MoveBetweenLists.setProperties($self);
				remove_values[remove_values.length] = remove_value;
				MoveBetweenLists.removeSelectedItems(remove_values);
			});

			// When "Remove All" button clicked, move all from right to left
			$(".move-between-lists .controls .remove-all").on('click', function removeAll(e) {
				var $self               = $(this),
				    remove_values       = [],
				    $options_not_hidden = null,
				    i                   = 0,
				    len                 = 0;

				e.preventDefault();
				MoveBetweenLists.setProperties($self);

				$options_not_hidden = MoveBetweenLists.rightElement.find('.option-container').not('.hidden');
				len                 = $options_not_hidden.length;

				if (len > 0) {
					Adzuki.CustomConfirm({
						body   : 'Are you sure you wish to remove all of the selected options?',
						confirm: function yes() {
							for (i; i < len; i++) {
								if (!$($options_not_hidden[i]).hasClass('read-only')) {
									remove_values[remove_values.length] = MoveBetweenLists.getDataValueInt($($options_not_hidden[i]));
								}
							}

							MoveBetweenLists.removeSelectedItems(remove_values);
						}
					});
				}
			});

			// If a group header is checked, check all of it's subs
			$(".move-between-lists .group-label :checkbox").on('change', function checkAllGroup(e) {
				var $self            = $(this),
				    is_checked       = $self.prop("checked"),
				    $group_div       = $self.parents('.group'),
				    $all_checked_arr = $group_div.find('.option-container :checkbox');

				MoveBetweenLists.toggleCheckedAllInGroup($all_checked_arr, is_checked);
			});


			// Remove entire group from right side
			$(".move-between-lists .right-field .remove-group").on('click', function removeGroup(e) {
				var $self         = $(this),
				    $options      = $self.parents('.group').find('.option-container').not('.hidden'),
				    remove_values = [];

				MoveBetweenLists.setProperties($self);

				$options.each(function removeEach(i, ele) {
					remove_values[remove_values.length] = MoveBetweenLists.getDataValueInt($(ele));
				});

				MoveBetweenLists.removeSelectedItems(remove_values);
			});

			// If the user is filtering the "from" list
			$(".move-between-lists .move-between-filter").on('keyup paste', function filterApply(e) {
				var $self = $(this),
				    $side;

				MoveBetweenLists.setProperties($self);

				if ($self.hasClass('right')) {
					$side = MoveBetweenLists.rightElement;
				} else {
					$side = MoveBetweenLists.leftElement;
				}

				// need to have a delay in case the user is not done typing
				if (filter_timeout) {
					clearTimeout(filter_timeout);
				}

				filter_timeout = setTimeout(function callExpensive() {
					var txt = $self.val();
					MoveBetweenLists.filterList(txt, $side);
				}, filter_delay);
			});

			$(".move-between-lists .clear-filter").on('click', function clearFilter(e) {
				var $self = $(this),
				    $side;

				MoveBetweenLists.setProperties($self);

				if ($self.hasClass('right')) {
					$side = MoveBetweenLists.rightElement;
				} else {
					$side = MoveBetweenLists.leftElement;
				}

				MoveBetweenLists.clearFilterList($side);
			});
		}
	};

	Adzuki.MoveBetweenLists = MoveBetweenLists;


	$(document).ready(MoveBetweenLists.init);

// close function scope and immediately execute function, passing window.Adzuki object as the argument
}(jQuery, window.Adzuki || {}));
